jQuery(document).ready(function( $ ){
	// START JQUERY

	affix_enable = (typeof affix_enable !== 'undefined')? affix_enable : true;
	affix_class = (typeof affix_class !== 'undefined')? affix_class : 'affix';
	affix_top = (typeof affix_top !== 'undefined')? affix_top : 'affix-top';

	affix_navbar_main = (typeof affix_navbar_main !== 'undefined')? affix_navbar_main : '#navMain';
	affix_navbar_sub = (typeof affix_navbar_sub !== 'undefined')? affix_navbar_sub : false;
	affix_navbar_height = (typeof affix_navbar_height !== 'undefined')? affix_navbar_height : 0;

	// set navbar height
	if($(affix_navbar_main).length) {
		affix_navbar_height = $(affix_navbar_main).outerHeight();
	}

	if (affix_enable) {
			function checkNavTop(el,off) {
				var top = $(window).scrollTop();
				if (top >= off) {
					$(el).addClass(affix_class);
					$(el).removeClass(affix_top);
				} else {
					$(el).removeClass(affix_class);
					$(el).addClass(affix_top);
				}
			}

			$(window).scroll(function(){
				checkNavTop(affix_navbar_main,affix_navbar_height);
				if(affix_navbar_sub) checkNavTop(affix_navbar_sub,subaffix_navbar_height);
			});

			$(window).on('load', function(){
				checkNavTop(affix_navbar_main,affix_navbar_height);
				if(affix_navbar_sub) checkNavTop(affix_navbar_sub,subaffix_navbar_height);
			});
	}

// END JQUERY
});
